export const TAB_LIST = [
    {
        text: "All Updates"
    },
    {
        text: "Blogs"
    },
    {
        text: "News & Events"
    }
]